import { Field, Form, Formik } from 'formik';
import Button from '../shared/buttons/button';
import FormInput from '../shared/forms/input';
import { required } from '../shared/forms/validations';
import { useUpdateOrderCodeMutation } from '../../hooks/react-query/use-order';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';

export type CodePropsType = {
  codeText: string;
  orderId: number;
};

function Code({ codeText, orderId }: CodePropsType) {
  const { formErrorMessage, setFormErrorMessage } = useFormErrorMessage();
  const { mutateAsync: updateOrderCode } = useUpdateOrderCodeMutation();
  return (
    <div className='my-4'>
      <Formik
        enableReinitialize
        initialValues={{ code: codeText }}
        onSubmit={async ({ code }) => {
          const defaultErrorMessage = codeText
            ? 'حذف کد تخفیف انجام نشد.'
            : 'کد تخفیف وارد شده معتبر نمی‌باشد.';
          await updateOrderCode(
            { orderId, code: codeText ? null : code },
            { onError: () => setFormErrorMessage(defaultErrorMessage) }
          );
        }}
      >
        {({ errors, dirty, isSubmitting }) => (
          <Form>
            <Field
              required
              inline
              disabled={!!codeText}
              name='code'
              label='کد تخفیف'
              component={FormInput}
              validate={[required]}
            />
            <Button
              color={codeText ? 'red' : 'blue'}
              inline
              type='submit'
              disabled={isSubmitting}
              content={codeText ? 'حذف کد تخفیف' : 'اعمال کد تخفیف'}
            />
            {dirty && formErrorMessage && (
              <p className='mt-3 mb-5 text-red-500'>{formErrorMessage}</p>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default Code;
